import React from "react";
import avatar from "assets/img/avatars/avatarSimmmple.png";
import { Agent } from "types";
import { Image } from "components/Image";

interface AgentItemProps {
  agent: Agent;
  isSelected: boolean;
  onClick: (agentId: string) => void;
}

const AgentItem: React.FC<AgentItemProps> = ({
  agent,
  isSelected,
  onClick,
}) => {
  return (
    <div
      className={`flex cursor-pointer items-center gap-3 rounded-lg p-3 transition-all duration-200 hover:bg-gray-50/80 dark:hover:bg-navy-700 ${
        isSelected
          ? "bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm   dark:bg-gradient-to-r dark:from-navy-700 dark:to-navy-900 dark:shadow-lg"
          : ""
      }`}
      onClick={() => onClick(agent.id)}
    >
      <Image
        src={agent.icon_uri}
        fallbackSrc={avatar}
        alt={agent.name || "Agent"}
        className="border-transparent h-8 w-8 rounded-full border-2 object-cover transition-transform hover:scale-105"
      />
      <span className="truncate text-sm font-medium text-[#6c6f93] transition-colors hover:text-[#4a4d6a] dark:text-gray-200 dark:hover:text-white">
        {agent.name || "Agent"}
      </span>
    </div>
  );
};
export default AgentItem;
